/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import AchievementCategoryName from '../../../common/components/AchievementCategoryName';

export default class AchievementHero extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { achievement, loading } = this.attrs;

		if (!achievement || loading) {
			return null;
		}

		const category = achievement.category();

		return (
			<div className="Hero">
				<div className="AchievementHero">
					{!loading &&
						achievement && [
							<h1 className="Hero-title">{achievement.name()}</h1>,
							<div className="Hero-subtitle">
								<Link href={app.route('achievements', { category: category.id() })}>
									<AchievementCategoryName category={category} />
								</Link>
								{achievement.description()}
							</div>,
						]}
				</div>
			</div>
		);
	}
}
